const state = {
    packageVersion: process.env.PACKAGE_VERSION || '0',
    gitVersion: process.env.GIT_HASH || '0'
};
const getters = {
    appVersion(state) {
        return state.packageVersion;
    },
    commitVersion(state) {
        return state.gitVersion;
    }
};
export default {
    getters,
    state
};
